import React from 'react';

function ActivityRow({ id, event, location, time }) {
  return (
    <div className="activity-row">
      <div className="activity-id">{id}</div>
      <div className="activity-event">{event}</div>
      {location && <div className="activity-loc">{location}</div>}
      <div className="activity-time">{time}</div>
    </div>
  );
}

export default ActivityRow;
